"use client";

import React from "react";
import { createIcon } from "@chakra-ui/react";

const OnTheSpotRegistrationIcon = createIcon({
  displayName: "OnTheSpotRegistrationIcon",
  viewBox: "0 0 45 37",
  path: (
    <>
      <path
        d="M22.5,30.06c.64,0,1.17-.22,1.6-.66.43-.44.65-.99.65-1.65s-.22-1.2-.65-1.65c-.43-.44-.97-.66-1.6-.66s-1.17.22-1.6.66c-.43.44-.65.99-.65,1.65s.22,1.2.65,1.65c.43.44.97.66,1.6.66ZM22.5,20.81c.64,0,1.17-.22,1.6-.66.43-.44.65-.99.65-1.65s-.22-1.2-.65-1.65c-.43-.44-.97-.66-1.6-.66s-1.17.22-1.6.66c-.43.44-.65.99-.65,1.65s.22,1.2.65,1.65c.43.44.97.66,1.6.66ZM22.5,11.56c.64,0,1.17-.22,1.6-.66.43-.44.65-.99.65-1.65s-.22-1.2-.65-1.65c-.43-.44-.97-.66-1.6-.66s-1.17.22-1.6.66c-.43.44-.65.99-.65,1.65s.22,1.2.65,1.65c.43.44.97.66,1.6.66ZM40.5,37H4.5c-1.24,0-2.3-.45-3.18-1.36-.88-.91-1.32-1.99-1.32-3.27v-9.25c1.24,0,2.3-.45,3.18-1.36.88-.91,1.32-1.99,1.32-3.27s-.44-2.36-1.32-3.27c-.88-.91-1.94-1.36-3.18-1.36V4.62c0-1.27.44-2.36,1.32-3.27.88-.91,1.94-1.36,3.18-1.36h36c1.24,0,2.3.45,3.18,1.36.88.91,1.32,1.99,1.32,3.27v9.25c-1.24,0-2.3.45-3.18,1.36-.88.91-1.32,1.99-1.32,3.27s.44,2.36,1.32,3.27c.88.91,1.94,1.36,3.18,1.36v9.25c0,1.27-.44,2.36-1.32,3.27-.88.91-1.94,1.36-3.18,1.36ZM40.5,32.38v-5.9c-1.39-.85-2.48-1.98-3.29-3.38-.81-1.41-1.21-2.94-1.21-4.6s.4-3.19,1.21-4.6c.81-1.41,1.9-2.53,3.29-3.38v-5.9H4.5v5.9c1.39.85,2.48,1.98,3.29,3.38.81,1.41,1.21,2.94,1.21,4.6s-.4,3.19-1.21,4.6c-.81,1.41-1.9,2.53-3.29,3.38v5.9h36Z"
        fill="currentColor"
      />
    </>
  ),
  defaultProps: {
    boxSize: "1em",
  },
});

export default OnTheSpotRegistrationIcon;
